import BaseStep from './BaseStep.js';
import {Helper} from "../../helpers/Helper.js";

export default class P2PFlows extends BaseStep {

	#startDateTimestamp
    _init() {

        this._MultiStepForms.Hook.addAction('addEvents', () => {
            this.#events()
        },0);

		this._MultiStepForms.Hook.addAction('init', () => {
			const formattedTime = Helper.date('Y-m-dTH:i');
			this.#startDateTimestamp = Helper.strtotime('now');

			this._MultiStepForms.formWrapper.querySelectorAll('input[name="campaign_start"]').forEach(el=>{
				if (!el.value){
					el.value = formattedTime;
				}
			});

			this._MultiStepForms.formWrapper.querySelectorAll('input[name="campaign_end"]').forEach(el=>{
				if (el.classList.contains('1Y')) {
					const newDate = new Date();
					newDate.setFullYear(newDate.getFullYear() + 1);
					el.value = Helper.date('Y-m-dTH:i', Helper.strtotime(newDate));
				}
			});

			this._MultiStepForms.formWrapper.querySelectorAll('input[name="campaign_goal"]').forEach(el=>{
				this.#handleGoal(el);
			});

			this._MultiStepForms.formWrapper.querySelectorAll('select[name="campaign_goal"]').forEach(el=>{
				this.#addGoalValueToGoalSelectOptions(el);
			});

		});

    }

    #events() {
		let prew_goal_name = ''

        this._MultiStepForms.handleEvent('change', this._MultiStepForms.formWrapper, (event) => {
            if (this._MultiStepForms.element(event.target, 'select.campaign-currency')) {
                const el = this._MultiStepForms.element(event.target, '.campaign-currency');

				const otherAmountLabels = this._MultiStepForms.formWrapper?.querySelectorAll('label.campaign_goal_other_amount-label');

				otherAmountLabels?.forEach(otherAmountLabel => {
					const icon = otherAmountLabel.querySelector('span');
					if (otherAmountLabel && icon) {
						icon.innerHTML = el.options[el.selectedIndex].dataset?.symbol || '';
					}
				})

				this.#addGoalValueToGoalSelectOptions(el);
            }

			if (this._MultiStepForms.element(event.target, 'select.campaign-goal')) {
                const el = this._MultiStepForms.element(event.target, '.campaign-goal');

				const selectedOptions = Array.from(el.selectedOptions);
				const noValueAttribute = selectedOptions.map(option => option.getAttribute('data-novalue')).join('');

				const otherWrapper = el.closest('form')?.querySelector('.campaign-goal-other-wrapper');
				const campaignGoalOtherAmountWrapper = el.closest('form')?.querySelector('.campaign_goal_other_amount_wrapper');
				const other_name = el.closest('form')?.querySelector('input[name="campaign_goal_other_name"]');
				const other_amount = el.closest('form')?.querySelector('input[name="campaign_goal_other_amount"]');

				if (otherWrapper) {
					if (el.value === 'other' || noValueAttribute) {
						otherWrapper.style.display = '';
						if (campaignGoalOtherAmountWrapper?.classList.contains('hidden')) campaignGoalOtherAmountWrapper?.classList.remove('hidden');
					} else {
						otherWrapper.style.display = 'none';
						if (!campaignGoalOtherAmountWrapper?.classList.contains('hidden')) campaignGoalOtherAmountWrapper?.classList.add('hidden');
					}
				}

				if (other_name){
					other_name.required = el.value === 'other'
				}

				if (other_amount){
					other_amount.required = el.value === 'other'
				}

				const checkboxes = this._MultiStepForms.formWrapper.querySelectorAll('input[type="checkbox"][name="unlimited_goal"]');
				if (checkboxes.length && el.value) {
					checkboxes.forEach(checkbox => {
						checkbox.checked = el.value === 'unlimited';
					});
				}

				prew_goal_name = el.value;

				if(prew_goal_name === 'other' || prew_goal_name === 'unlimited'){
					prew_goal_name = '';
				}
            }

			if (this._MultiStepForms.element(event.target, 'input[type="checkbox"][name="unlimited_goal"]')) {
				const checkbox = event.target;

				const isUnlimited = checkbox.checked;

				const goals = this._MultiStepForms.formWrapper?.querySelectorAll('select[name="campaign_goal"]');
				const goal = goals[0] || null;

				const other_names = this._MultiStepForms.formWrapper.querySelectorAll('input[name="campaign_goal_other_name"]');
				const other_amounts = this._MultiStepForms.formWrapper.querySelectorAll('input[name="campaign_goal_other_amount"]');

				if (other_names.length){
					other_names.forEach(other_name => other_name.required = false);
				}

				if (other_amounts.length){
					other_amounts.forEach(other_amount => other_amount.required = false);
				}

				if (goal || typeof other_amounts[0] !== 'undefined'){
					const field = goal || other_amounts[0];
					const values = document.querySelectorAll(`[data-name="${field.name}"]`).forEach((value) => {
						this._MultiStepForms.childClasses.DefaultFields.setVisibleValue(value, field)
					})
				}

				if (!goal || !goal.querySelector('option[value="unlimited"]')) return;

				const otherWrapper = checkbox.closest('form')?.querySelector('.campaign-goal-other-wrapper');
				if (otherWrapper) {
					otherWrapper.style.display = 'none';
				}

				if (isUnlimited) {
					goals.forEach((goal) => {
						for (const option of goal.options) {
							if (option.value === 'unlimited') {
								goal.value = option.value;
								option.selected = true;
								break;
							}
						}

						const preview = goal.closest('.form-group.is-edit')?.querySelector('.goal.form-field-value');

						if (preview) {
							preview.textContent = goal.options[goal.selectedIndex].textContent;
						}
					});
				} else {
					goals.forEach((goal) => {
						for (const option of goal.options) {
							if (option.value == prew_goal_name) {
								goal.value = option.value;
								option.selected = true;
								break;
							}
						}

						// if (goal.value === 'unlimited') {
						// 	goal.value = '';
						// }

						goal.removeAttribute('disabled');

						const preview = goal.closest('.form-group.is-edit')?.querySelector('.goal.form-field-value');

						if (preview) {
							preview.textContent = goal.value || '';
						}

					});
				}
            }

			if (this._MultiStepForms.element(event.target, 'input[type="checkbox"][name="campaign_not_has_end"]')) {
				const checkbox = event.target;

				const checked = checkbox.checked;

				const endDates = this._MultiStepForms.formWrapper?.querySelectorAll('input[name=campaign_end]');



				if (!endDates.length) return;

				endDates.forEach(endDate => {
					endDate.required = !checked;
					if(checked) {
						endDate.value = '';
					}
				});
				document.querySelectorAll(`[data-name="campaign_end"]`).forEach((value) => {
					this._MultiStepForms.childClasses.DefaultFields.setVisibleValue(value, endDates[0])
				});
            }

			if (this._MultiStepForms.element(event.target, 'input[type="date"],input[type="datetime-local"],input[type="month"],input[type="time"],input[type="week"]')) {
				const field = this._MultiStepForms.element(event.target, 'input[type="date"],input[type="datetime-local"],input[type="month"],input[type="time"],input[type="week"]')

				const formats = {
					date: 'Y-m-d',
					'datetime-local': 'Y-m-dTH:i',
					month: 'Y-m',
					time: 'H:i',
					week: `Y-WW`
				}

				const currentTime = Helper.date(formats[field.type]);

				if (Helper.strtotime(field.value) < Helper.strtotime('now')) {
					field.value = currentTime;
				}
			}

			if (this._MultiStepForms.element(event.target, 'input[name="campaign_end"]')){
				const endField = this._MultiStepForms.element(event.target, 'input[name="campaign_end"]');
				const startField = endField.closest('form').querySelector('input[name="campaign_start"]');
				const campaign_not_has_end = endField.closest('form').querySelector('input[name="campaign_not_has_end"]');

				const startDate = startField.value;
				const endDate = endField.value;

				if (startDate && endDate && Helper.strtotime(startDate) >= Helper.strtotime(endDate)){
					this._MultiStepForms.error(endField, 'Starting date cannot be higher than end date')

					endField.value = '';
				} else {
					this._MultiStepForms.clearErrors();
				}
				if(campaign_not_has_end && campaign_not_has_end.checked) {
					campaign_not_has_end.checked = false;
				}
			}

			if (this._MultiStepForms.element(event.target, 'input[name="campaign_start"]')){
				const startField = this._MultiStepForms.element(event.target, 'input[name="campaign_start"]');
				const endField = startField.closest('form').querySelector('input[name="campaign_end"]');

				const startDate = startField.value;
				const endDate = endField.value;

				const offset = Helper.strtotime(endDate) - this.#startDateTimestamp;

				const newEndDate = Helper.date('Y-m-dTH:i', Helper.strtotime(startDate) + offset)

				endField.value = newEndDate;

				this.#startDateTimestamp = Helper.strtotime(startDate)
			}

			if (this._MultiStepForms.element(event.target, 'input[name="campaign_goal_other_amount"]')){
				if (this._MultiStepForms.formWrapper.querySelector('[name="campaign_goal"]')){
					const field = this._MultiStepForms.element(event.target, 'input[name="campaign_goal_other_amount"]');
					const values = document.querySelectorAll(`[data-name="campaign_goal"]`).forEach((value) => {
						this._MultiStepForms.childClasses.DefaultFields.setVisibleValue(value, field)
					})
				}
			}
		});

    }

	#addGoalValueToGoalSelectOptions(el = null) {
		let goal;
		let currency;

		if (el?.matches('select[name="campaign_goal"]')) {
			goal = el;
			currency = el?.closest('form')?.dataset.currency?.toLowerCase();;
		} else {
			goal = el?.closest('form')?.querySelector('select[name="campaign_goal"]');
			currency = el?.value?.toLowerCase();
		}

		if (goal) {
			const options = [...goal.options];

			//sort goal options by goal value
			options.sort(function(a, b) {
				var aValue = parseInt(a.dataset[currency]?.replace(/[^0-9]/g, '') || 0, 10);
				var bValue = parseInt(b.dataset[currency]?.replace(/[^0-9]/g, '') || 0, 10);

				if (a.value === "" || a.value === "unlimited" || a.value === "other" || b.value === "" || b.value === "unlimited" || b.value === "other") {
					return 0;
				}

				return aValue - bValue;
			});

			//Add currency and goal value in front of the goal option
			for (const option of options) {
				if (['unlimited','other',''].includes(option.value)){
					goal.add(option);
					continue;
				}

				if (![undefined,'',null].includes(option.dataset[currency])) {
					option.textContent = option.dataset[currency] + ' - ' + option.value;
				} else {
					option.textContent = option.value;
				}

				goal.add(option)
			}
		}

	}

	#handleGoal(el = null) {
		el = this._MultiStepForms.element(el, '.campaign-goal');

		const otherWrapper = el.closest('form')?.querySelector('.campaign-goal-other-wrapper');

		const other_name = el.closest('form')?.querySelector('input[name="campaign_goal_other_name"]');
		const other_amount = el.closest('form')?.querySelector('input[name="campaign_goal_other_amount"]');

		if (otherWrapper) {
			if (el.value === 'other' ) {
				otherWrapper.style.display = '';
			} else {
				otherWrapper.style.display = 'none';
			}
		}

		if (other_name){
			other_name.required = el.value === 'other'
		}

		if (other_amount){
			other_amount.required = el.value === 'other'
		}

		const checkboxes = this._MultiStepForms.formWrapper.querySelectorAll('input[type="checkbox"][name="unlimited_goal"]');
		if (checkboxes.length && el.value) {
			checkboxes.forEach(checkbox => {
				checkbox.checked = el.value === 'unlimited';
			});
		}
	}
}
